import axios from "axios"
import { saveAs } from "file-saver"

const apiUrl = "/api/"

function buildUrl(path) {
  return `${apiUrl}${path}`
}

function buildOptions(options = {}, signal = null) {
  if (!options.headers) {
    options.headers = {}
  }

  if (signal) options.signal = signal

  options.headers.Authorization = localStorage.getItem("token")
  return options
}

function blobToBase64(blob) {
  return new Promise((resolve, _) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.readAsDataURL(blob)
  })
}
export default {
  // Login and Registration
  getEmailAlreadyUsed(mail) {
    let url = buildUrl("user/check/mail/in/use")
    return axios.post(url, mail, buildOptions()).then((res) => res.data)
  },
  updatePushToken(token) {
    let url = buildUrl("push/token")
    return axios.post(url, token, buildOptions()).then((res) => res.data)
  },
  generateAccount(data) {
    let url = buildUrl("register/generate")
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },

  changePassword(data) {
    let url = buildUrl(`forgot/${data.key}`)

    return axios.post(url, data).then((res) => res.data)
  },
  // Verification
  resetPWAdmin(email) {
    let url = buildUrl(`forgotadmin/${email}`)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  resetPassword(data) {
    let url = buildUrl("forgot")

    return axios.post(url, data).then((res) => res.data)
  },
  sendMail(data) {
    let url = buildUrl("mail")

    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  authenticate(credentials) {
    let url = buildUrl("login")

    return axios.post(url, credentials).then((res) => res.data)
  },

  registerUser(credentials) {
    let url = buildUrl("register")

    return axios.post(url, credentials).then((res) => res.data)
  },
  saveConsent(customerSignature) {
    let url = buildUrl("user/consent")

    return axios.post(url, { customerSignature: customerSignature }, buildOptions()).then((res) => res.data)
  },
  saveDisclosureAggreement(customerSignature) {
    let url = buildUrl("user/non-disclosure-aggreement")

    return axios.post(url, { customerSignature: customerSignature }, buildOptions()).then((res) => res.data)
  },
  renewToken(signal = null) {
    let url = buildUrl("renew/token")

    return axios.get(url, buildOptions({}, signal)).then((res) => res.data)
  },
  verifyEmailVerificationCode(data) {
    let url = buildUrl("user/email/verification/verify")
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  startEmailVerification() {
    let url = buildUrl("user/email/verification/start")
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  fetchUserEmailVerificationStatus() {
    let url = buildUrl("user/email/verification/status")
    return axios.get(url, buildOptions()).then((res) => res.data)
  },

  // Rights
  saveUserRoles(users) {
    let url = buildUrl("user/edit/role")

    return axios.post(url, users).then((res) => res.data)
  },
  fetchUserRightList() {
    let url = buildUrl("user/rightlist/all")
    return axios.get(url, buildOptions()).then((res) => res.data)
  },

  deleteRight(data) {
    let url = buildUrl("rights/delete")
    return axios.put(url, { right: JSON.stringify(data) }, buildOptions()).then((res) => res.data)
  },
  upsertRight(data) {
    let url = buildUrl("rights")
    return axios.put(url, data, buildOptions()).then((res) => res.data)
  },
  fetchRightsAndTopics() {
    let url = buildUrl(`rightsandtopics`)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  createNewRightsTopic(data) {
    let url = buildUrl(`rightstopic`)
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  fetchAllRights() {
    let url = buildUrl(`rights`)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  fetchAllUserRoles() {
    let url = buildUrl(`user/roles`)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  fetchAllRoles() {
    let url = buildUrl(`roles`)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  updateExistingUserRole(data) {
    let url = buildUrl(`roles`)
    return axios.put(url, data, buildOptions()).then((res) => res.data)
  },
  createUserRole(data) {
    let url = buildUrl(`roles`)
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  deleteUserRole(role_id) {
    let url = buildUrl(`roles/${role_id}`)
    return axios.delete(url, buildOptions()).then((res) => res.data)
  },

  fetchRolesForUser(userId) {
    let url = buildUrl(`user/roles/${userId}`)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  getUserRights() {
    let url = buildUrl("user/rights")

    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  getUserRolle() {
    let url = buildUrl("rolle")

    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  // Notifications
  markAllNotificationsAsRead() {
    let url = buildUrl("notifications/mark/all/as/read")
    return axios.get(url, buildOptions()).then((res) => res.data)
  },

  // Slim-ME
  fetchSlimMeUsers() {
    let url = buildUrl("user/slim-me")
    return axios.get(url, buildOptions()).then((res) => res.data)
  },

  // User CRUD

  getUserforSignups(signups, id) {
    let data = {
      signups,
      id,
    }
    let url = buildUrl(`user/getlist/signups`)

    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  getUserById(id) {
    let url = buildUrl(`user/getbyid/` + id)

    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  getAllUserList(signal = null) {
    let url = buildUrl(`user/getlist/all`)

    return axios.get(url, buildOptions({}, signal)).then((res) => res.data)
  },
  getUserList() {
    let url = buildUrl(`user/getlist`)

    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  getUser() {
    let url = buildUrl(`user`)

    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  pickStudio(studio) {
    let url = buildUrl("pickstudio")

    return axios.put(url, studio, buildOptions()).then((res) => res.data)
  },
  editUserProfileFromContract(data) {
    let url = buildUrl("user/edit/profile/contract")

    return axios.put(url, data, buildOptions()).then((res) => res.data)
  },
  editUserProfile(user) {
    let url = buildUrl("user/edit/profile")

    return axios.put(url, user, buildOptions()).then((res) => res.data)
  },
  editUser(user) {
    user = JSON.parse(user)

    let url = buildUrl(`user/${JSON.parse(user.oldUser).email}`)

    return axios.put(url, JSON.parse(user.newUser), buildOptions()).then((res) => res.data)
  },

  deleteUser(userid) {
    let url = buildUrl(`user/delete`)

    return axios.post(url, userid, buildOptions()).then((res) => res.data)
  },
  deleteOwnAccount(userid) {
    let url = buildUrl(`user/delete/self`)

    return axios.post(url, userid, buildOptions()).then((res) => res.data)
  },
  editRolle(data) {
    let url = buildUrl(`rolle`)

    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },

  searchUserforRolle(data) {
    let url = buildUrl(`rolle/list`)

    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  fetchAllUsers() {
    //let url = buildUrl(`fetch/users/all`)
    let url = "https://app.wellcomefit.ch/api/fetch/users/all"

    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  lookupUsers(search, signal = null) {
    let url = buildUrl(`fetch/users/all`)
    //let url = "https://app.wellcomefit.ch/api/fetch/users/all"

    return axios.post(url, { search }, buildOptions({}, signal)).then((res) => res.data)
  },
  getUserForManager(id) {
    let url = buildUrl(`fetch/users/usersearch/` + id)

    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  getUserForManagerByEmail(email) {
    let url = buildUrl(`fetch/users/usersearchemail/` + email)

    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  getOwnUserForManager() {
    let url = buildUrl(`fetch/users/ownUser`)

    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  getCustomerDashboard(id) {
    let url = buildUrl(`fetch/customer/dashboard/` + id)

    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  getCustomerDashboardTraining(id) {
    let url = buildUrl(`fetch/customer/dashboard/training/` + id)

    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  updateUserGuestEntries(data) {
    let url = buildUrl(`user/guest-entry`)

    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  setUserBirthday(date) {
    let url = buildUrl("user/birthday")
    return axios.post(url, { date }, buildOptions()).then((res) => res.data)
  },

  updateUserInfo(data) {
    let url = buildUrl("user/update/info")
    return axios.put(url, { data }, buildOptions()).then((res) => res.data)
  },
  addTargetWeightToUser(weight) {
    let url = buildUrl("user/add/targetWeight")

    return axios.put(url, { weight: weight }, buildOptions()).then((res) => res.data)
  },
  addNewWeightToUser(weight) {
    let url = buildUrl("user/add/weight")

    return axios.put(url, { weight: weight }, buildOptions()).then((res) => res.data)
  },

  // Membercard

  createMembercardLead(userId) {
    let url = buildUrl(`membercard/createlead/${userId}`)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  fetchMembercardLeads() {
    let url = buildUrl("membercard/leads")
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  fetchPastMembercardLeads(days) {
    let url = buildUrl("membercard/leads/" + days)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  fetchMembercardLead(userId) {
    let url = buildUrl(`membercard/fetchlead/${userId}`)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  updateMembercard(data) {
    let url = buildUrl(`membercard/user`)
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  startMembercard(data) {
    let url = buildUrl(`membercard/user/start`)
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  createMembercard(id) {
    let url = buildUrl(`tendays/create/membercard/${id}`)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  aboLoesen(id) {
    let url = buildUrl(`tendays/abos/loesen/${id}`)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  getMembercards() {
    let url = buildUrl("tendays/membercard/download")
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  getKampagneInvites() {
    let url = buildUrl(`tendays/membercard/invites/download`)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },

  createFeedbackTendays(feedback) {
    let url = buildUrl(`tendays/feedback`)
    return axios.post(url, feedback, buildOptions()).then((res) => res.data)
  },

  subscribe(subscription) {
    let url = buildUrl(`subscription`)
    return axios.post(url, { subscription: subscription }, buildOptions()).then((res) => res.data)
  },
  td_anmelden(id) {
    let url = buildUrl(`tendays/anmelden/${id}`)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  td_aboAnfragen() {
    let url = buildUrl(`tendays/abos`)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  td_buyAbo() {
    let url = buildUrl(`tendays/buy`)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  td_cancelAbo() {
    let url = buildUrl(`tendays/cancel`)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  // Studio
  getUserStudio() {
    let url = buildUrl("user/standort")
    return axios.get(url, buildOptions()).then((res) => res.data)
  },

  fetchUserMescanData() {
    console.log("returning data from API hahaha")
    return [
      {
        data: {
          water: {
            unit: "kg",
            absolute: {
              total: 41.5,
              extraCellular: 16.2,
              intraCellular: 25.3,
            },
            percentage: {
              total: 63.6,
              extraCellular: 24.8,
              intraCellular: 38.8,
              balance: 38.9,
              distribution: 61,
            },
          },
          fat: {
            unit: "kg",
            absolute: {
              total: 5.8,
              essentialFat: 3.9,
              fatReserve: 1.9,
              excessiveFat: 0,
              visceralFat: 1,
            },
            percentage: {
              total: 8.9,
              essentialFat: 6,
              fatReserve: 2.8,
              excessiveFat: 0,
              visceralFat: 1.5,
            },
          },
          oxygen: {
            unit: "%",
            percentage: {
              spo2: 99,
            },
          },
          cellFitness: {
            unit: "°",
            absolute: {
              cellFitnessValue: 5.4,
              cellFitnessMaxValue: 6.1,
            },
          },
          muscle: {
            unit: "kg",
            absolute: {
              muscleProtein: 9.8,
              muscleWater: 19.7,
              total: 29.5,
              leftArm: 1.7,
              rightArm: 1.6,
              leftLeg: 6.2,
              rightLeg: 6,
              trunk: 14,
            },
            percentage: {
              muscleProtein: 33.2,
              muscleWater: 66.8,
              bodyMuscleProtein: 15,
              bodyMuscleWater: 30.2,
              total: 45.2,
              leftArm: 2.6,
              rightArm: 2.5,
              leftLeg: 9.5,
              rightLeg: 9.2,
              trunk: 21.4,
            },
          },
          bioAge: {
            absolute: {
              bioAge: 31.55151,
            },
          },
          heartRate: {
            unit: "bpm",
            absolute: {
              avgHeartRate: 70,
            },
          },
          workoutReadiness: {
            absolute: {
              workoutReadiness: 57,
            },
            meta: {
              workoutReadinessRating: "WORKOUT_READINESS_GOOD",
            },
          },
          trainingRanges: {
            absolute: {
              regenerativeMin: 92,
              regenerativeMax: 111,
              basicExtensiveMax: 129,
              basicIntensiveMax: 148,
              developmentMax: 166,
              peakMax: 185,
            },
            meta: {
              rangesNotRecommended: ["peakMax"],
            },
          },
        },
        rating: {
          waterTotal: {
            index: 7,
            ranges: {
              absolute: [[31], [31, 32.4], [32.5, 34.4], [34.5, 36.4], [36.5, 38.4], [38.5, 40.3], [40.3]],
              percentage: [[47.5], [47.5, 49.6], [49.7, 52.7], [52.8, 55.7], [55.8, 58.8], [58.9, 61.8], [61.8]],
            },
          },
          waterBalance: {
            index: 5,
            ranges: {
              absolute: [[43.9], [43.9, 41.8], [41.7, 40.8], [40.7, 39.7], [39.6, 38.7], [38.6, 37.7], [37.7]],
            },
          },
          waterDistribution: {
            index: 1,
            ranges: {
              absolute: [[61.8], [61.8, 62.1], [62.2, 62.3], [62.4, 62.6], [62.7, 62.9], [63, 63.2], [63.2]],
            },
          },
          fatTotal: {
            index: 7,
            ranges: {
              absolute: [[22.1], [22.1, 18.2], [18.1, 16.3], [16.3, 14.4], [14.4, 12.5], [12.4, 10.6], [10.6]],
              percentage: [[51.9], [51.9, 42.7], [42.6, 38.3], [38.2, 33.9], [33.8, 29.3], [29.2, 24.8], [24.8]],
            },
          },
          visceralFat: {
            index: 7,
            ranges: {
              absolute: [[5.4], [5.4, 4.5], [4.4, 3.7], [3.6, 2.9], [2.8, 2.1], [2, 1.2], [1.2]],
            },
          },
          spo2: {
            index: 3,
            ranges: {
              percentage: [[91], [91, 94], [95, 100]],
            },
          },
          muscleTotal: {
            index: 4,
            ranges: {
              absolute: [[27.9], [27.9, 28.4], [28.5, 28.9], [29, 29.8], [29.9, 30.6], [30.7, 31.5], [31.5]],
              percentage: [[42.6], [42.6, 43.5], [43.6, 44.3], [44.4, 45.7], [45.8, 46.9], [47, 48.3], [48.3]],
            },
          },
          bioAge: {
            index: 2,
            ranges: {
              absolute: [[35], [31, 35], [31]],
            },
          },
          cellFitnessValue: {
            index: 4,
            ranges: {
              absolute: [[4.4], [4.4, 4.7], [4.8, 5.1], [5.2, 5.4], [5.5, 5.8], [5.9, 6.1], [6.1]],
            },
          },
          heartRate: {
            index: 7,
            ranges: {
              absolute: [[109], [109, 105], [104, 100], [99, 90], [89, 85], [84, 80], [80]],
            },
          },
          workoutReadiness: {
            index: 4,
            ranges: {
              absolute: [
                [
                  {
                    key: "WORKOUT_READINESS_NONE",
                  },
                ],
                [
                  {
                    key: "WORKOUT_READINESS_VERY_LOW",
                  },
                ],
                [
                  {
                    key: "WORKOUT_READINESS_LOW",
                  },
                ],
                [
                  {
                    key: "WORKOUT_READINESS_MODERATE",
                  },
                ],
                [
                  {
                    key: "WORKOUT_READINESS_GOOD",
                  },
                ],
                [
                  {
                    key: "WORKOUT_READINESS_VERY_GOOD",
                  },
                ],
                [
                  {
                    key: "WORKOUT_READINESS_OPTIMAL",
                  },
                ],
              ],
            },
          },
          muscleLeftArm: {
            index: 4,
            ranges: {
              absolute: [[1.5], [1.5, 1.5], [1.6, 1.6], [1.7, 1.7], [1.8, 1.8], [1.9, 2], [2]],
              percentage: [[2.3], [2.3, 2.4], [2.5, 2.5], [2.6, 2.7], [2.8, 2.8], [2.9, 3.1], [3.1]],
            },
          },
          muscleRightArm: {
            index: 3,
            ranges: {
              absolute: [[1.5], [1.5, 1.5], [1.6, 1.6], [1.7, 1.7], [1.8, 1.8], [1.9, 2], [2]],
              percentage: [[2.3], [2.3, 2.4], [2.5, 2.5], [2.6, 2.7], [2.8, 2.8], [2.9, 3.1], [3.1]],
            },
          },
          muscleLeftLeg: {
            index: 6,
            ranges: {
              absolute: [[5.6], [5.6, 5.6], [5.7, 5.7], [5.8, 5.9], [6, 6.1], [6.2, 6.4], [6.4]],
              percentage: [[8.6], [8.6, 8.6], [8.7, 8.8], [8.9, 9.1], [9.2, 9.4], [9.5, 9.8], [9.8]],
            },
          },
          muscleRightLeg: {
            index: 5,
            ranges: {
              absolute: [[5.6], [5.6, 5.6], [5.7, 5.7], [5.8, 5.9], [6, 6.1], [6.2, 6.4], [6.4]],
              percentage: [[8.6], [8.6, 8.6], [8.7, 8.8], [8.9, 9.1], [9.2, 9.4], [9.5, 9.8], [9.8]],
            },
          },
          muscleTrunk: {
            index: 5,
            ranges: {
              absolute: [[13.4], [13.4, 13.5], [13.6, 13.6], [13.7, 13.9], [14, 14.1], [14.2, 14.5], [14.5]],
              percentage: [[20.5], [20.5, 20.7], [20.8, 20.9], [21, 21.3], [21.4, 21.7], [21.8, 22.2], [22.2]],
            },
          },
        },
        measurementInfo: {
          migrated: false,
        },
        userInfo: {
          _id: "5f0319b151cd0b032357de55",
          firstname: "Max",
          lastname: "Mustermann",
          gender: "male",
          weight: 65.27,
          height: 180,
          target: ["HEALTHY_LIVING"],
        },
        // von Sebi hinzugefügt ToDo
        date: "2024-12-30T23:00:00",
      },
      {
        data: {
          water: {
            unit: "kg",
            absolute: {
              extraCellular: Math.round(16.2 * 1.12 * 10) / 10, // ca. 18.1
              intraCellular: Math.round(25.3 * 1.12 * 10) / 10, // ca. 28.4
              total: Math.round((16.2 * 1.12 + 25.3 * 1.12) * 10) / 10, // ca. 46.5
            },
            percentage: {
              extraCellular: Math.round(24.8 * 1.12 * 10) / 10, // ca. 27.8
              intraCellular: Math.round(38.8 * 1.12 * 10) / 10, // ca. 43.5
              total: Math.round((24.8 * 1.12 + 38.8 * 1.12) * 10) / 10, // ca. 71.3
              balance: Math.round(38.9 * 1.12 * 10) / 10, // ca. 43.6
              distribution: Math.round(61 * 1.12 * 10) / 10, // ca. 68.3
            },
          },
          fat: {
            unit: "kg",
            absolute: {
              essentialFat: Math.round(3.9 * 1.12 * 10) / 10, // ca. 4.4
              fatReserve: Math.round(1.9 * 1.12 * 10) / 10, // ca. 2.1
              excessiveFat: 0,
              total: Math.round((3.9 * 1.12 + 1.9 * 1.12) * 10) / 10, // ca. 6.5
              visceralFat: Math.round(1 * 1.12 * 10) / 10, // ca. 1.1
            },
            percentage: {
              essentialFat: Math.round(6 * 1.12 * 10) / 10, // ca. 6.7
              fatReserve: Math.round(2.8 * 1.12 * 10) / 10, // ca. 3.1
              excessiveFat: 0,
              total: Math.round((6 * 1.12 + 2.8 * 1.12) * 10) / 10, // ca. 9.9
              visceralFat: Math.round(1.5 * 1.12 * 10) / 10, // ca. 1.7
            },
          },
          oxygen: {
            unit: "%",
            percentage: {
              spo2: 99, // keine Änderung, da nahe am Maximum
            },
          },
          cellFitness: {
            unit: "°",
            absolute: {
              cellFitnessValue: Math.round(5.4 * 1.12 * 10) / 10, // ca. 6.0
              cellFitnessMaxValue: Math.round(6.1 * 1.12 * 10) / 10, // ca. 6.8
            },
          },
          muscle: {
            unit: "kg",
            absolute: {
              muscleProtein: Math.round(9.8 * 1.12 * 10) / 10, // ca. 11.0
              muscleWater: Math.round(19.7 * 1.12 * 10) / 10, // ca. 22.1
              total: Math.round((9.8 * 1.12 + 19.7 * 1.12) * 10) / 10, // ca. 33.1
              leftArm: Math.round(1.7 * 1.12 * 10) / 10, // ca. 1.9
              rightArm: Math.round(1.6 * 1.12 * 10) / 10, // ca. 1.8
              leftLeg: Math.round(6.2 * 1.12 * 10) / 10, // ca. 6.9
              rightLeg: Math.round(6 * 1.12 * 10) / 10, // ca. 6.7
              // trunk = (total - (leftArm + rightArm + leftLeg + rightLeg))
              trunk: Math.round((9.8 + 19.7 - 1.7 - 1.6 - 6.2 - 6) * 1.12 * 10) / 10, // ca. 15.7
            },
            percentage: {
              muscleProtein: Math.round(33.2 * 1.12 * 10) / 10, // ca. 37.2
              muscleWater: Math.round(66.8 * 1.12 * 10) / 10, // ca. 74.9
              total: Math.round(45.2 * 1.12 * 10) / 10, // ca. 50.6
              bodyMuscleProtein: Math.round(15 * 1.12 * 10) / 10, // ca. 16.8
              bodyMuscleWater: Math.round(30.2 * 1.12 * 10) / 10, // ca. 33.8
              leftArm: Math.round(2.6 * 1.12 * 10) / 10, // ca. 2.9
              rightArm: Math.round(2.5 * 1.12 * 10) / 10, // ca. 2.8
              leftLeg: Math.round(9.5 * 1.12 * 10) / 10, // ca. 10.6
              rightLeg: Math.round(9.2 * 1.12 * 10) / 10, // ca. 10.3
              trunk: Math.round(21.4 * 1.12 * 10) / 10, // ca. 24.0
            },
          },
          bioAge: {
            absolute: {
              bioAge: Math.round(31.55151 * 1.12 * 10) / 10, // ca. 35.3
            },
          },
          heartRate: {
            unit: "bpm",
            absolute: {
              avgHeartRate: Math.round(70 * 1.12), // ca. 78
            },
          },
          workoutReadiness: {
            absolute: {
              workoutReadiness: Math.round(57 * 1.12), // ca. 64
            },
            meta: {
              workoutReadinessRating: "WORKOUT_READINESS_GOOD",
            },
          },
          trainingRanges: {
            absolute: {
              regenerativeMin: Math.round(92 * 1.12), // ca. 103
              regenerativeMax: Math.round(111 * 1.12), // ca. 124
              basicExtensiveMax: Math.round(129 * 1.12), // ca. 144
              basicIntensiveMax: Math.round(148 * 1.12), // ca. 166
              developmentMax: Math.round(166 * 1.12), // ca. 186
              peakMax: Math.round(185 * 1.12), // ca. 207
            },
            meta: {
              rangesNotRecommended: ["peakMax"],
            },
          },
        },
        rating: {
          waterTotal: {
            index: 7,
            ranges: {
              absolute: [[31], [31, 32.4], [32.5, 34.4], [34.5, 36.4], [36.5, 38.4], [38.5, 40.3], [40.3]],
              percentage: [[47.5], [47.5, 49.6], [49.7, 52.7], [52.8, 55.7], [55.8, 58.8], [58.9, 61.8], [61.8]],
            },
          },
          waterBalance: {
            index: 5,
            ranges: {
              absolute: [[43.9], [43.9, 41.8], [41.7, 40.8], [40.7, 39.7], [39.6, 38.7], [38.6, 37.7], [37.7]],
            },
          },
          waterDistribution: {
            index: 1,
            ranges: {
              absolute: [[61.8], [61.8, 62.1], [62.2, 62.3], [62.4, 62.6], [62.7, 62.9], [63, 63.2], [63.2]],
            },
          },
          fatTotal: {
            index: 7,
            ranges: {
              absolute: [[22.1], [22.1, 18.2], [18.1, 16.3], [16.3, 14.4], [14.4, 12.5], [12.4, 10.6], [10.6]],
              percentage: [[51.9], [51.9, 42.7], [42.6, 38.3], [38.2, 33.9], [33.8, 29.3], [29.2, 24.8], [24.8]],
            },
          },
          visceralFat: {
            index: 7,
            ranges: {
              absolute: [[5.4], [5.4, 4.5], [4.4, 3.7], [3.6, 2.9], [2.8, 2.1], [2, 1.2], [1.2]],
            },
          },
          spo2: {
            index: 3,
            ranges: {
              percentage: [[91], [91, 94], [95, 100]],
            },
          },
          muscleTotal: {
            index: 4,
            ranges: {
              absolute: [[27.9], [27.9, 28.4], [28.5, 28.9], [29, 29.8], [29.9, 30.6], [30.7, 31.5], [31.5]],
              percentage: [[42.6], [42.6, 43.5], [43.6, 44.3], [44.4, 45.7], [45.8, 46.9], [47, 48.3], [48.3]],
            },
          },
          bioAge: {
            index: 2,
            ranges: {
              absolute: [[35], [31, 35], [31]],
            },
          },
          cellFitnessValue: {
            index: 4,
            ranges: {
              absolute: [[4.4], [4.4, 4.7], [4.8, 5.1], [5.2, 5.4], [5.5, 5.8], [5.9, 6.1], [6.1]],
            },
          },
          heartRate: {
            index: 7,
            ranges: {
              absolute: [[109], [109, 105], [104, 100], [99, 90], [89, 85], [84, 80], [80]],
            },
          },
          workoutReadiness: {
            index: 4,
            ranges: {
              absolute: [
                [
                  {
                    key: "WORKOUT_READINESS_NONE",
                  },
                ],
                [
                  {
                    key: "WORKOUT_READINESS_VERY_LOW",
                  },
                ],
                [
                  {
                    key: "WORKOUT_READINESS_LOW",
                  },
                ],
                [
                  {
                    key: "WORKOUT_READINESS_MODERATE",
                  },
                ],
                [
                  {
                    key: "WORKOUT_READINESS_GOOD",
                  },
                ],
                [
                  {
                    key: "WORKOUT_READINESS_VERY_GOOD",
                  },
                ],
                [
                  {
                    key: "WORKOUT_READINESS_OPTIMAL",
                  },
                ],
              ],
            },
          },
          muscleLeftArm: {
            index: 4,
            ranges: {
              absolute: [[1.5], [1.5, 1.5], [1.6, 1.6], [1.7, 1.7], [1.8, 1.8], [1.9, 2], [2]],
              percentage: [[2.3], [2.3, 2.4], [2.5, 2.5], [2.6, 2.7], [2.8, 2.8], [2.9, 3.1], [3.1]],
            },
          },
          muscleRightArm: {
            index: 3,
            ranges: {
              absolute: [[1.5], [1.5, 1.5], [1.6, 1.6], [1.7, 1.7], [1.8, 1.8], [1.9, 2], [2]],
              percentage: [[2.3], [2.3, 2.4], [2.5, 2.5], [2.6, 2.7], [2.8, 2.8], [2.9, 3.1], [3.1]],
            },
          },
          muscleLeftLeg: {
            index: 6,
            ranges: {
              absolute: [[5.6], [5.6, 5.6], [5.7, 5.7], [5.8, 5.9], [6, 6.1], [6.2, 6.4], [6.4]],
              percentage: [[8.6], [8.6, 8.6], [8.7, 8.8], [8.9, 9.1], [9.2, 9.4], [9.5, 9.8], [9.8]],
            },
          },
          muscleRightLeg: {
            index: 5,
            ranges: {
              absolute: [[5.6], [5.6, 5.6], [5.7, 5.7], [5.8, 5.9], [6, 6.1], [6.2, 6.4], [6.4]],
              percentage: [[8.6], [8.6, 8.6], [8.7, 8.8], [8.9, 9.1], [9.2, 9.4], [9.5, 9.8], [9.8]],
            },
          },
          muscleTrunk: {
            index: 5,
            ranges: {
              absolute: [[13.4], [13.4, 13.5], [13.6, 13.6], [13.7, 13.9], [14, 14.1], [14.2, 14.5], [14.5]],
              percentage: [[20.5], [20.5, 20.7], [20.8, 20.9], [21, 21.3], [21.4, 21.7], [21.8, 22.2], [22.2]],
            },
          },
        },
        measurementInfo: {
          migrated: false,
        },
        userInfo: {
          _id: "5f0319b151cd0b032357de55",
          firstname: "Max",
          lastname: "Mustermann",
          gender: "male",
          weight: Math.round(65.27 * 1.12 * 10) / 10, // ca. 73.1
          height: 180,
          target: ["HEALTHY_LIVING"],
        },
        date: "2024-12-10T23:00:00",
      },
    ]
  },
}
